"use strict";
exports.__esModule = true;
exports.NodeDefs = void 0;
var _1 = require(".");
var isEntity = function (nodeDef) { return nodeDef.type === _1.NodeDefType.entity; };
var isSingleEntity = function (nodeDef) { return isEntity(nodeDef) && !nodeDef.props.multiple; };
var isAttribute = function (nodeDef) { return !isEntity(nodeDef); };
var isRoot = function (nodeDef) { return !nodeDef.parentUuid; };
exports.NodeDefs = {
    isEntity: isEntity,
    isSingleEntity: isSingleEntity,
    isAttribute: isAttribute,
    isRoot: isRoot
};
//# sourceMappingURL=nodeDefs.js.map